export type SupportTicketCategory =
  | 'ACCOUNT'
  | 'BILLING'
  | 'BOOKING'
  | 'TECHNICAL'
  | 'QUESTION'
  | 'FEEDBACK'
  | 'OTHER';

export type SupportTicketApp =
  | 'CLIENT'
  | 'THERAPIST'
  | 'BETWEEN_SESSIONS'
  | 'EMPLOYEE'
  | 'EMPLOYER'
  | 'BROKER'
  | 'IMWELL'
  | 'IMWELL_STUDENTS'
  | 'IMWELL_CLINICIAN'
  | 'IMWELL_ADMIN'
  | 'RESOLVE';

export type SupportMessageRole = 'SUBMITTER' | 'ADMIN' | 'SYSTEM';
export type SupportMessageVisibility = 'PUBLIC' | 'INTERNAL';

export interface SupportAttachment {
  path: string;
  name: string;
  type: string;
  /** Optional signed URL — populated server-side for rendering. */
  url?: string | null;
  size?: number;
}

export interface SupportMessage {
  id: string;
  role: SupportMessageRole;
  visibility: SupportMessageVisibility;
  authorUserId?: string | null;
  authorProId?: string | null;
  authorEmail?: string | null;
  authorName?: string | null;
  body: string;
  attachments: SupportAttachment[];
  createdAt: string;
}

export interface PickerOption {
  value: string;
  label: string;
}

export interface PickerConfig {
  field: 'episodeId' | 'groupId' | 'sessionId' | 'companyId';
  label: string;
  options: PickerOption[];
  optional?: boolean;
}

export interface SupportPrefill {
  sourceApp: SupportTicketApp;
  userId?: string | null;
  proId?: string | null;
  submitterEmail?: string | null;
  submitterName?: string | null;
  appVersion?: string | null;
}

export interface SupportTicketSummary {
  id: string;
  ticketNumber: number;
  accessToken: string;
  subject: string;
  category: SupportTicketCategory;
  status: string;
  priority: string;
  body: string;
  messages: SupportMessage[];
  attachments: SupportAttachment[];
  createdAt: string;
  updatedAt: string;
  /** Admin-set "resolve by" deadline. Read-only on submitter views. */
  dueAt?: string | null;
}

export const SUPPORT_CATEGORY_LABELS: Record<SupportTicketCategory, string> = {
  ACCOUNT: 'Account',
  BILLING: 'Billing',
  BOOKING: 'Booking',
  TECHNICAL: 'Technical issue',
  QUESTION: 'Question',
  FEEDBACK: 'Feedback',
  OTHER: 'Other',
};
